import React from 'react';
import { DNABox, DNAButton, DNAText } from '@alucio/lux-ui';
import { useAppSettings } from 'src/state/context/AppSettings';
import { useCRMStatus } from 'src/hooks/useCRMStatus';
import { useUserTenant } from 'src/state/redux/selector/user';
import { useActor } from '@xstate/react';
import { CRMSyncStatus } from 'src/state/machines/CRM/crmMachineTypes';
import withPermissionsAccessControl from 'src/hooks/useFeatureFlags/withPermissionsAccessControl';
import { CRMUtil } from 'src/state/machines/CRM/util';
import { useDispatch } from 'src/state/redux';
import { drawerActions } from 'src/state/redux/slice/drawer';
interface Props {
  errorMessage?: string;
}

const MeetingCRMAuth = (props: Props) => {
  const { errorMessage } = props;
  const currentTenant = useUserTenant();
  const { crmMachine } = useAppSettings();
  const { syncStatus, displayCRMConnectButton } = useCRMStatus();
  const dispatch = useDispatch();

  const [, send] = useActor(crmMachine);

  const isInError = errorMessage || syncStatus === CRMSyncStatus.ERROR;

  const msg =  isInError
    ? errorMessage || 'CRM is disconnected, please reconnect. If the issue persists, please contact support.'
    : 'Your organization has enabled CRM integration. Please log into your CRM to sync the latest data.';

  const btnMsg = isInError
    ? 'Reconnect to CRM'
    : 'Connect to CRM';

  if (!displayCRMConnectButton) return null;

  const handleConnect = async () => {
    CRMUtil.clearPostAuthIntent();
    dispatch(drawerActions.clearCRMAutoSubmit());
    send({
      type: 'LOGIN_CRM',
      payload: currentTenant?.config.crmIntegration,
    })
  }

  return (
    <DNABox
      appearance="col"
      spacing="md"
      alignX="center"
      alignY="center"
      fill
      style={{ backgroundColor: 'white', minHeight: 172 }}
    >
      <DNAText status="subtle">
        {msg}
      </DNAText>
      <DNAButton onPress={handleConnect}>
        {btnMsg}
      </DNAButton>
    </DNABox>
  )
}

const MeetingCRMAuthAcessControl = withPermissionsAccessControl(
  MeetingCRMAuth,
  { flags: ['enableCrmIntegration'] },
)

export default MeetingCRMAuthAcessControl
